import { render, staticRenderFns } from "./CrossSample.vue?vue&type=template&id=5fe465d0&scoped=true"
import script from "./CrossSample.vue?vue&type=script&lang=js"
export * from "./CrossSample.vue?vue&type=script&lang=js"
import style0 from "./CrossSample.vue?vue&type=style&index=0&id=5fe465d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe465d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
